/* eslint-disable react/jsx-pascal-case */

import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import React, { useState, Suspense, lazy } from "react";
import 'react-slideshow-image/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import { useCustomer } from '../../customers/useCustomer';
import '../../Helper/links';
import { BookingProvider } from '../BookingContext';
import BookingApartmentStep from './BookingApartmentStep';
import BookingApartmentTowStep from './BookingApartmentTowStep';
import BookingConfirmStep from './BookingConfirmStep';
import BookingCustomerStep from "./BookingCustomerStep";
function Booking() {
    const customer = useCustomer();
    const [bookingApartmentData, setbookingApartmentData] = useState([]);
    const [bookingCustomerData, setbookingCustomerData] = useState(customer);

    const handleApartmentData = (data) => {
        var have_id_apartment = false;
        bookingApartmentData.map((index) => {
            if (index.id_apartment === data.id_apartment) {
                have_id_apartment = true;
                return index.dates = data.dates;
            }
            return 0;
        })
        if (!have_id_apartment) {
            setbookingApartmentData([...bookingApartmentData, {
                id_apartment: data.id_apartment,
                dates: data.dates
            }])
        }
    };
    const handleCustomertData = (data) => {
        setbookingCustomerData(data)
    };
    return (
        <div className="page-wrapper" dir="rtl"   >
            <div className="content-wrapper">

                <div className="page-heading">
                    <h1 className="page-title"> إنشــاء حجــوزات </h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="index.html"><i className="la la-home font-20"></i></a>
                        </li>
                    </ol>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ibox">
                            <BookingProvider>
                                <Stepper style={{ flexBasis: '50rem', fontFamily: "Cairo" }} headerPosition="bottom" icon='pi pi-users'>
                                    <StepperPanel key="apartment-step-1" activeIndex='var(--primary-color)' header={<p>نــوع الإقـــامة </p>} icon="pi pi-user" style={{ margin: "0", padding: "0", width: "100%" }} title='sd'>
                                        <BookingApartmentStep onDataChange={handleApartmentData} bookingApartmentData={bookingApartmentData} ></BookingApartmentStep>
                                    </StepperPanel>
                                    {/* <StepperPanel key="apartment-step-2" activeIndex='var(--primary-color)' header={<p>نــوع الإقـــامة</p>} icon="pi pi-user" style={{ margin: "0", padding: "0", width: "100%" }} title='sd'>
                                        <BookingApartmentTowStep onDataChange={handleApartmentData} bookingApartmentData={bookingApartmentData} ></BookingApartmentTowStep>
                                    </StepperPanel> */}

                                    <StepperPanel key="customer-step" header={<p>العميـــل</p>}>
                                        <BookingCustomerStep onDataChange={handleCustomertData} bookingCustomerData={bookingCustomerData} />
                                    </StepperPanel>

                                    <StepperPanel key="confirm-step" header={<p>تــاكيد الحجــز</p>}>
                                        <BookingConfirmStep bookingApartmentData={bookingApartmentData} setbookingApartmentData={setbookingApartmentData} bookingCustomerData={bookingCustomerData} setbookingCustomerData={setbookingCustomerData}></BookingConfirmStep>
                                    </StepperPanel>
                                </Stepper>
                            </BookingProvider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Booking

